// Event-day tables store floor_plan_id and venue_id as uuids (the kal database). These helpers keep an id that is not a uuid from
// being sent as if it were one.

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** The uuid as is, null for "no floor plan", undefined when the id cannot be sent (so a saved link is kept, never wiped). */
export function floorPlanIdForApi(id: string): string | null | undefined {
  if (!id) return null;
  return UUID.test(id) ? id.toLowerCase() : undefined;
}

/** True only when every floor plan id is one the table API can store. */
export function canLinkFloorPlans(plans: ReadonlyArray<{ id: string | number }>): boolean {
  return plans.every(p => UUID.test(String(p.id)));
}

export interface TableFormValues {
  number: string;
  name: string;
  section: string;
  capacity: string;
  floor_plan_id: string;
}

/** `venueId` is the venue of the chosen floor plan; it travels with the plan so the table knows its room. */
export function buildTablePayload(form: TableFormValues, venueId?: string | null) {
  const floor_plan_id = floorPlanIdForApi(form.floor_plan_id);
  const venue = floor_plan_id === null ? null : floor_plan_id && venueId && UUID.test(venueId) ? venueId.toLowerCase() : undefined;
  return {
    number: Number(form.number),
    name: form.name || undefined,
    section: form.section || undefined,
    capacity: form.capacity ? Number(form.capacity) : undefined,
    floor_plan_id,
    ...(venue !== undefined ? { venue_id: venue } : {}),
  };
}
